module.exports = __webpack_public_path__ + "72f999e383afe099ebfe1fce81d3c0ee.woff2";